module.exports = __webpack_public_path__ + "img/restaurant-5.12de8d40.jpg";